import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { bundlesApi } from '@/api/endpoints/bundles'
import { getErrorMessage } from '@/shared/utils/error-codes'
import { ApiError } from '@/api/types'

export function usePublishBundle() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (restaurantId: number) => bundlesApi.publish(restaurantId),
    onSuccess: (data) => {
      // Invalidate overview query to refresh bundle versions
      queryClient.invalidateQueries({ queryKey: ['overview'] })

      toast.success(`Bundle version ${data.version} published successfully`)
    },
    onError: (error: Error) => {
      if (error instanceof ApiError) {
        toast.error(getErrorMessage(error.status, error.code))
      } else {
        toast.error('Failed to publish bundle')
      }
    },
  })
}
